import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { NavRail } from './NavRail';
import { MobileNav } from './MobileNav';
import { cn } from '@/lib/utils';

export function AppLayout() {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 rounded-2xl gradient-gold animate-pulse shadow-glow-lg" />
          <p className="text-xs uppercase tracking-widest text-muted-foreground font-bold">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Redirect to onboarding if not completed
  if (profile && !profile.onboarded) {
    return <Navigate to="/onboarding" replace />;
  }

  const isDashboard = location.pathname === '/dashboard';

  return (
    <div className="min-h-screen bg-background flex">
      {/* Navigation Rail (Desktop) */}
      <NavRail />
      
      {/* Main content */}
      <div className={cn(
        "flex-1 flex flex-col min-w-0",
        "lg:ml-[72px]" // Rail width
      )}>
        {/* Main content area */}
        <main className={cn(
          "flex-1 overflow-x-hidden",
          isDashboard 
            ? "p-0 lg:p-6 lg:pr-6" 
            : "p-4 lg:p-6 pb-24 lg:pb-6"
        )}>
          <div className={cn(
            isDashboard ? "h-full" : "animate-fade-in"
          )}>
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileNav />
    </div>
  );
}
